// @flow

export const UPDATE_ERROR = "UPDATE_ERROR";